import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormControl, ValidationErrors } from '@angular/forms';

export function sinValidator(control: FormControl): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }

  // Remove non-digits
  const sin = value.toString().replace(/\D/g, '');

  if (sin.length !== 9) {
    return { sin: true };
  }

  // Luhn algorithm for SIN
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let digit = parseInt(sin.charAt(i), 10);
    if ((i % 2) === 1) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }

  return (sum % 10) === 0 ? null : { sin: true };
}

@Component({
  selector: 'formly-sin-input',
  template: `
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>{{ props.label }}</mat-label>
      <input
        matInput
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        mask="000-000-000"
        [placeholder]="props.placeholder || '000-000-000'"
      />
      <mat-error *ngIf="formControl.invalid && formControl.touched">
        <formly-validation-message [field]="field"></formly-validation-message>
      </mat-error>
    </mat-form-field>
  `,
})
export class SinInputType extends FieldType<FieldTypeConfig> {}
